import styled, {css} from 'styled-components';

export const StatsChart = styled.div`
    width: 300px;
    height: 300px;
    border-radius: 50%;
    background: linear-gradient(90deg, lightgray 50%, transparent 50%), 
        linear-gradient(-90deg, lightgray 50%, #9ec400 50%);
    margin: 30px;
    display: flex;
    align-items: center;
    justify-content: center;
    
    ${({ratio}) =>
        (ratio >= 0 && ratio <= 0.5) ? 
            css`
                background: linear-gradient(${-360 * ratio + 90}deg, lightgray 50%, transparent 50%), 
                    linear-gradient(-90deg, lightgray 50%, #9ec400 50%);
            ` :
            css`
               background: linear-gradient(${-360 * ratio + 270}deg, #9ec400 50%, transparent 50%), 
                    linear-gradient(90deg, #9ec400 50%, lightgray 50%);
            `
    };
    
    @media (max-width: 320px) {
        transform: scale(0.8);
    }
`;

export const StatsChartWrapper = styled.div`
    width: 800px;
    display: flex;
    align-items: center;
    justify-content: center;
    flex-direction: row;
    flex-wrap: wrap;
    
    @media (max-width: 800px) {
        max-width: 800px;
        width: auto;
    }
`;

export const ChartLegend = styled.p`
    font-size: 16px;
    font-family: BlenderProBold, serif;
    letter-spacing: 1px;
`;

export const ChartLegendDesc = styled.p`
    font-size: 13px;
    font-family: Roboto Condensed, serif;
    font-weight: 300;
    margin: 0;
    margin-bottom: 30px;
`;

export const ChartLegendContainer = styled.div`
    display: flex;
    align-items: center;
    justify-content: center;
    flex-direction: column;
    text-align: center;
    max-width: 220px;
`;

export const InnerCircle = styled.div`
    width: 250px;
    height: 250px;
    border-radius: 50%;
    background-color: #F7FAF2;
    display: flex;
    align-items: center;
    justify-content: center;
`;

export const InnerText = styled.div`
    font-family: BlenderProBold, serif;
    font-size: 90px;
    color: black;
`;
